<template>
    <div>
        <b-modal :id="modalSerialId"
            modal-class="modal-serial"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head serial-head">
                    <div id="serial_campaign">
                        <img class="img-cl" :src="campaign.fullImageUrl" />
                    </div>
                </div>
                <!--Show code-->
                <div class="modal-base-body">
                    <div class="modal-head-txt">{{ campaign.name }}</div>
                    <div class="modal-head-msg" v-html="getPointMessage()"></div>
                    
                    <div class="serial-block"
                        v-if="objSerialCode.isShowCode && campaign.serial">
                        <div class="serial-wrapper serial-tab-wrapper">
                            <div class="serial-tab"
                                @click="clickChangeTab('QR_CODE')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'QR_CODE'}">{{lblSerial.qr_code}}</div>
                                </div>
                            <div class="serial-tab"
                                @click="clickChangeTab('CODE_128')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'CODE_128'}">{{lblSerial.barcode}}</div>
                                </div>
                            <div class="serial-tab"
                                @click="clickChangeTab('CODE')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'CODE'}">{{lblSerial.code}}</div>
                                </div>
                        </div>
                        <div class="serial-wrapper serial-tab-wrapper">
                            <div class="serial-tabline"
                                :class="{'tabline-active': objSerialCode.strCodeType === 'QR_CODE'}"
                                @click="clickChangeTab('QR_CODE')"></div>
                            <div class="serial-tabline"
                                :class="{'tabline-active': objSerialCode.strCodeType === 'CODE_128'}"
                                @click="clickChangeTab('CODE_128')"></div>
                            <div class="serial-tabline"
                                :class="{'tabline-active': objSerialCode.strCodeType === 'CODE'}"
                                @click="clickChangeTab('CODE')"></div>
                        </div>
                        <div id="serial_code_wrapper"
                            class="serial-wrapper">
                            <div id="serial_show_code">{{getFixShowCodeTxt()}}</div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'CODE'">
                                <p id="code"
                                    :class="{'long-code': campaign.serial.length > 12, 'serial-expire' : campaign.serial === 'XXXXXXX'}">
                                    {{campaign.serial === 'XXXXXXX' ? 'XXXXXXX' : campaign.serial}}</p>
                                <div class="serial-copy" @click="copySerial()" :class="{'expired': timer.isExpired}">
                                    <img class="img-fluid" src="@/assets/icon/ic-copy-new.svg" />
                                    <div class="serial-copy-txt">{{ copyMessage }}</div>      
                                </div> 
                                <div v-if="timer.isExpired" class="expired-overlay">
                                     {{ lblSerial.code_expired }}
                                </div>
                            </div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'CODE_128'">
                                <vue-barcode id="barcode"
                                    :class="{'expired': timer.isExpired}"
                                    :value="campaign.serial"
                                    :options="objBarcodeConfig"></vue-barcode>
                                <div v-if="timer.isExpired" class="expired-overlay">
                                    {{ lblSerial.code_expired }}
                                </div>
                            </div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'QR_CODE'">
                                <vue-qrcode id="qrcode"
                                    :class="{'expired': timer.isExpired}"
                                    :value="campaign.serial"
                                    :options="objQrCodeConfig"></vue-qrcode>
                                <div v-if="timer.isExpired" class="expired-overlay">
                                    {{ lblSerial.code_expired }}
                                </div>
                            </div>
                            <div id="serial_privilege_msg"
                                v-if="objSerialMessage.strMessage"
                                v-html="cleanMessage(objSerialMessage.strMessage)"></div>
                        </div>
                    </div>
                    <!--Not show code-->
                    <div class="serial-block"
                        v-if="!objSerialCode.isShowCode">
                        <div class="serial-wrapper">
                            <p class="serial-privilege-message"
                                v-html="cleanMessage(objSerialMessage.strMessage)"></p>
                        </div>
                    </div>
                </div>
                <!--Timer-->
                <div class="modal-base-footer">
                    <div class="serial-block">
                        <div id="serial_bottom_wrapper" class="serial-wrapper">
                            <div class="serial-col">
                                <div class="serial_txt">{{ lblSerial.redeem_on }}</div>
                                <div class="serial_redeem_date">{{getRedeemDate(campaign.redeemDate)}}</div>
                            </div>
                            <div class="border-right"></div>
                            <div class="serial-col">
                                <div class="serial_txt">{{lblSerial.expire_in}}</div>
                                <div id="serial_expire" v-if="timer.isShowTimer">
                                    <div id="serial_expire_time" :class="{'serial-expire': timer.isExpired}">{{timer.displayTime}}</div>
                                </div>
                                <div v-else class="serial_redeem_date">
                                    {{getRedeemDate(campaign.expireDate)}}
                                </div>
                            </div>
                        </div>
                        <div id="serial-close">
                            <div class="btn-wrapper btn-cancel" @click="clickClose()">
                                <div class="btn-txt">ปิด</div>      
                            </div>
                        </div>
                        <div class="serial-logo">
                            <img class="img-fluid" src="@/assets/bzbslogo/new-logo-gray.png" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal :id="modalPrivilege"
            modal-class="modal-privilege"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="privilege_modal_title" class="modal-head-txt privilege-modal-txt theme-txt" v-html="lblSerial.redeem_success_headline"></p>
                </div>
                <div class="modal-base-body">
                    <div class="serial-block">
                        <div class="serial-wrapper"
                            v-if="objSerialMessage.strMessageType === 'privilege'">
                            <p class="modal-body-txt privilege-modal-msg"
                                v-html="cleanMessage(this.objSerialMessage.strMessage)"></p>
                            <p class="modal-body-txt privilege-modal-msg"
                                v-if="campaign.derivered">{{lblSerial.delivery}}</p>
                        </div>
                        <div class="serial-wrapper"
                            v-if="objSerialMessage.strMessageType === 'delivery'">
                            <p id="serial_draw_delivery" class="modal-body-txt privilege-modal-msg"
                                v-html="cleanMessage(this.objSerialMessage.strMessage)"></p>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div id="privilege_modal_btn_row">
                        <div class="privilege-modal-btn">
                            <div class="btn-wrapper btn-cancel">
                                <div class="btn-txt"
                                    @click="clickClose">
                                    {{lblSerial.redeem_success_close}}
                                </div>
                            </div>
                        </div>
                        <div class="privilege-modal-btn">
                            <div class="btn-wrapper">
                                <div class="btn-txt"
                                    @click="clickAction('history')">
                                    {{lblSerial.redeem_success_history}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal :id="modalPasscode"
            modal-class="modal-serial"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head serial-head">
                    <div id="serial_campaign">
                        <img class="img-cl" :src="campaign.fullImageUrl" />
                    </div>
                </div>
                <div class="modal-base-body">
                    <div class="serial-block serial-passcode">
                        <div class="serial-passcode-txt theme-txt">{{lblSerial.passcode_headline}}</div>
                        <!-- <div class="serial-passcode-txt">{{lblSerial.passcode_sub_headline}}</div> -->
                        <div id="serial_passcode_input">
                            <div class="input-wrapper">
                                <input type="tel"
                                    id="serial_passcode"
                                    v-model="passcode.value"
                                    maxlength="5"
                                    @input="validatePasscode()" />
                                <div class="input-placeholder"
                                    v-show="!passcode.value">
                                    {{lblSerial.passcode.placeholder}}</div>
                                <div class="input-clear"
                                    v-show="passcode.value"
                                    @click="clickClearPasscode">
                                    <img class="img-fluid" src="../../../../assets/icon/icon_del.png" />
                                </div>
                            </div>
                            <div class="input-error-txt"
                                v-if="passcode.isSubmit && !passcode.isValid">
                                {{passcode.errMsg}}</div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="serial-block serial-passcode">
                        <div id="passcode_btn_row">
                            <div class="passcode-btn">
                                <div class="btn-wrapper btn-cancel">
                                    <div class="btn-txt"
                                        @click="clickPasscodeCancel">
                                        {{lblSerial.passcode_cancel}}
                                    </div>
                                </div>
                            </div>
                            <div class="passcode-btn">
                                <div class="btn-wrapper">
                                    <div class="btn-txt"
                                        @click="clickPasscodeConfirm">
                                        {{lblSerial.passcode_confirm}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
//plugin
import VueBarcode from '@chenfengyuan/vue-barcode'; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import VueQrcode from '@chenfengyuan/vue-qrcode'; // https://github.com/fengyuanchen/vue-qrcode
//helper
import Util from '@/helper/Utility.js';
import Moment from 'moment';
import Locale from '@/helper/locale/locale.js';
import TimerHelper from '@/helper/TimerHelper.js';
//service
import DetailService from '@/module/Detail/service/DetailService.js';
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {object} busSerialModal (required) Modal Controller.
 * Event
 * @event clickChangeTab Change serial code type.
 * @event clickAction
 * Method
 * @method show Setup serial modal with campaign.
 * @method hide Stop interval and close modal.
 * Interval
 * @method startInterval Start serial interval.
 * @method stopInterval Stop serial interval.
 * @method serialExpired Set serial modal to expired state.
 * @method initialSerialTimer Setup time information and start interval.
 * @method timeFormatter Format timestamp to count down timer.
 * Utilities
 * @method cleanMessage Replace \n to <br/>
 * @method getRedeemDate Convert time stamp to readable format.
 * @method getDrawMessage Create message for campaign type draw.
 */
export default {
    name: 'SerialModal',
    components: {
        VueBarcode,
        VueQrcode
    },
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function() {
        return {
            campaign: {},
            page: '',
            tag: '',
            isPasscode: false,
            //helper
            timer: new TimerHelper(),

            lbl: Locale.getLbl(),
            lblDate: {},
            lblSerial: {},

            isLoading: false,

            modalType: 'serial', //serial, privilege
            modalSerialId: this.modalId+'modal_serial',
            modalPrivilege: this.modalId+'modal_sprivilege',
            modalPasscode: this.modalId+'modal_passcode',
            interval: null,
            isTabLock: false,

            objSerialMessage: {
                strHeadline: '',
                strMessage: '',
                strMessageType: '',
            },
            objSerialCode: {
                isShowCode: true,
                strCodeType: '', //CODE_128,QR_CODE,CODE
            },
            objBarcodeConfig: {
                height: 50,
                displayValue: true,
                lineColor: '#000000'
            },
            objQrCodeConfig: {
                width: 200
            },

            passcode: {
                isSubmit: false,
                isValid: true,
                errMsg: '',
                value: ''
            },
            passcode_category: [],
            copyMessage: 'คัดลอก',

            //bus
            busModal: null
        };
    },
    created: function () {
        this.lblDate = this.lbl.date;
        this.lblSerial = this.lbl.serial;

        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //Event
        clickChangeTab: function(strCurrentTab) {
            if (this.isTabLock) return;

            this.objSerialCode.strCodeType = strCurrentTab;
        },
        clickAction: function (action) {
            this.hide();
            switch(action) {
                case 'history':
                    this.controller.sendCallbackAction({ tag: this.tag, action: action });
                    break;
                default:
                    this.controller.sendCallbackAction({ tag: this.tag, action: action });
                    break;
            }
        },
        clickClose: function () {
            this.hide();
            this.controller.sendCallbackClose({tag: this.tag});
            window.location.reload();
        },
        //End Event
        //method
        show: function(config) {
            this.isTabLock = false
            this.campaign = Util.normalObject(config.campaign);
            this.page = config.page;
            this.tag = config.tag;
            this.passcode_category = config.passcode_category;

            this.timerHelper = new TimerHelper();

            //Clear interval
            if(this.timer.interval)
                this.timer.stopTimer();

            if (this.campaign.delivered === true ||
                this.campaign.type === Vue.CampaignType.Draw)
                this.modalType = 'draw_or_delivery';

            var cateArr = this.passcode_category;
            var cateFiltered = cateArr.filter(val => {
               return (this.campaign.categoryID == val)
            });

            this.isPasscode = (cateFiltered.length > 0);

            //Initial modal type
            if (this.isPasscode) {
                this.showPasscode();
            } else {
                switch (this.modalType) {
                    case 'serial':
                        this.showSerial();
                        break;
                    case 'draw_or_delivery':
                        this.showDrawOrDelivery();
                        break;
                }
            }
        },
        showSerial: function () {
            //Initial serial tab
            switch (this.campaign.barcode) {
                case 'CODE_128':
                    this.objSerialCode.strCodeType = 'CODE_128';
                    break;
                case 'QR_CODE':
                    this.objSerialCode.strCodeType = 'QR_CODE';
                    break;
                default:
                    if (this.campaign.barcode.toLowerCase() === 'none' &&
                        this.campaign.privilegeMessage)
                        this.objSerialCode.isShowCode = false;

                    this.objSerialCode.strCodeType = 'CODE';
                    break;
            }

            //Set privilege message fonmat
            if (this.campaign.privilegeMessageFormat &&
                this.campaign.privilegeMessageFormat.toLowerCase() === 'html') {
                if (this.campaign.privilegeMessage)
                    this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
            } else {
                if (this.campaign.privilegeMessage)
                    this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                // else
                //     this.objSerialMessage.strMessage = this.lblSerial.show_code_at_shop;
            }

            //Set isShowTimer
            // this.campaign.expireIn = 5
            this.timer.initialTimer(this.campaign.expireIn, ':', true, false);
            this.timer.runTimer(this.serialExpired);

            this.tag += '-serial';
            this.$bvModal.show(this.modalSerialId);
        },
        showDrawOrDelivery: function () {
            if (this.campaign.privilegeMessage) {
                this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                this.objSerialMessage.strMessageType = 'privilege';
            } else {
                if (this.campaign.delivered === true) {
                    this.objSerialMessage.strMessage = this.lblSerial.delivery;
                    this.objSerialMessage.strMessageType = 'delivery';
                }

                if (this.campaign.type === Vue.CampaignType.Draw) {
                    this.objSerialMessage.strMessage = this.getDrawMessage(this.lblSerial.draw);
                    this.objSerialMessage.strMessageType = 'privilege';
                }
            }

            this.tag += '-privilege';
            this.$bvModal.show(this.modalPrivilege);
        },
        showPasscode: function () {
            this.tag += '-passcode';
            this.passcode.value = '';
            this.$bvModal.show(this.modalPasscode);
        },
        hide: function() {
            switch(this.modalType) {
                case 'serial':
                    this.timer.stopTimer();
                    this.$bvModal.hide(this.modalSerialId);
                    break;
                case 'draw_or_delivery':
                    this.$bvModal.hide(this.modalPrivilege);
                    break;
            }

            this.controller.sendCallbackClose({tag: this.tag});
        },
        hidePasscode: function() {
            this.$bvModal.hide(this.modalPasscode);
        },
        //timer
        serialExpired: function() {
            this.clickPasscodeCancel();
            this.objSerialCode.strCodeType = 'CODE';
            this.isTabLock = false;
            // this.isTabLock = true;

            this.campaign.serial = "XXXXXXX";
            this.timer.isExpired = true;

            this.timer.timerExpired();
            this.controller.sendCallbackAction({ tag: this.tag, action: 'expired' });
        },
        //Utility
        cleanMessage: function (message) {
            return Util.newLineToBr(message);
        },
        getRedeemDate: function (redeemDate) {
            if (!redeemDate) return;

            // var message = this.lblSerial.redeem_on;
            var result = Moment.unix(redeemDate).utc();
            var year = Moment.unix(redeemDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = result.format('MM');
            var day = result.format('DD');
            var date = `${day}/${month}/${year}`;
            var time = result.format('HH:mm');
            // return Util.stringFormat(message, date, time);
            return Util.stringFormat(date, time);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = `${result.format('DD')} ${monthString} ${year}`;

            return Util.stringFormat(message, strDate);
        },
        getFixShowCodeTxt: function () {
            if (this.objSerialCode.strCodeType == 'CODE_128') {
                return Util.stringFormat(this.lblSerial.show_code_fix, this.lblSerial.barcode);
            } else if (this.objSerialCode.strCodeType == 'QR_CODE') {
                return Util.stringFormat(this.lblSerial.show_code_fix, this.lblSerial.qr_code);
            } else {
                return Util.stringFormat(this.lblSerial.show_code_fix, this.lblSerial.code);
            }
        },
        //passcode
        clickPasscodeConfirm: function () {
            if (this.showLoading()) return;

            this.passcode.isSubmit = true;
            this.validatePasscode();
            if (this.passcode.isValid) {
                //TODO: Call Api
                DetailService.sendPasscode(this.passcode.value, this.campaign.serial, this.campaign.agencyID)
                    .then(() => {
                        this.hideLoading();
                        this.passcode.value = '';
                        this.hidePasscode();
                        if (this.modalType == 'draw_or_delivery') {
                            this.showDrawOrDelivery();
                        } else {
                            this.controller.sendCallbackClose({tag: this.tag});
                        }
                    }).catch(err => {
                        this.hideLoading();
                        this.passcode.isValid = false;
                        if (err.response && err.response.data && err.response.data.error) {
                            switch(err.response.data.error.id) {
                                case 403:
                                    this.passcode.errMsg = this.lblSerial.passcode.not_correct;
                                    break;
                                default:
                                    this.passcode.errMsg = err.response.data.error.message;
                                    break;
                            }
                        } else {
                            this.passcode.errMsg = "ไม่สามารถเชื่อมต่ออินเตอร์เน็ต กรุณาลองใหม่อีกครั้ง";
                        }
                    });
            } else {
                this.$nextTick(() => {
                    this.hideLoading();
                });
            }
        },
        clickPasscodeCancel: function () {
            this.passcode.isSubmit = false;
            this.passcode.isValid = true;
            this.passcode.errMsg = '';
            this.passcode.value = '';

            this.hidePasscode();
        },
        clickClearPasscode: function () {
            this.passcode.value = '';
        },
        passcodeReset: function () {
            this.passcode.isSubmit = false;
            this.passcode.isValid = true;
            this.passcode.errMsg = '';
            this.passcode.value = '';
        },
        validatePasscode: function () {
            //remove restrict character.
            var input = this.passcode.value.replace(Vue.RegExp.emoji, '');
            this.passcode.value = input.replace(Vue.RegExp.notNumber, '');

            this.passcode.isValid = true;
            this.passcode.errMsg = '';
            //required
            if (this.lblSerial.passcode.required
                && !this.passcode.value) {
                this.passcode.isValid = false;
                this.passcode.errMsg = this.lblSerial.passcode.required;
            }
            //too short
            if (this.lblSerial.passcode.too_short
                && this.passcode.value.length < 5) {
                this.passcode.isValid = false;
                this.passcode.errMsg = this.lblSerial.passcode.too_short;
            }
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return `<div class="text-point">${pointType} <span class="points">${Util.formatNum(this.campaign.pointPerUnit)}</span> ${pointUnit}</div>`;
        },
        copySerial: function() {
            // Use native clipboard API
            navigator.clipboard.writeText(this.campaign.serial).then(() => {
                this.copyMessage = "คัดลอกแล้ว!";
                setTimeout(() => {
                    this.copyMessage = "คัดลอก";
                }, 500);
            }).catch(err => {
                console.error('ไม่สามารถคัดลอกได้:', err);
            });
        },
        //loading
        showLoading: function () {
            if (this.isLoading) return true;
            this.isLoading = true;

            this.controller.loadingModal.show();
            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.controller.loadingModal.hide();
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
@import "./SerialModal.scss";
@import "./PrivilegeModal.scss";
</style>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/base/common.scss";
    @import "@/style/modal.scss";

    .modal-serial {
        @extend %modal-base;

        .modal-dialog {
            max-width: 360px;
        };

        .modal-body {
            padding: 24px 16px;
        }

        .modal-base-head {
            margin-bottom: 16px
        }
      
        .modal-head-txt {
            @extend %ellipsis-2;
            text-align: left !important;
            color: $a-gray-333333;
            margin-bottom: 10px;
        }
        
        .modal-head-msg {
            margin-bottom: 16px;

            .text-point {
                font-size: 1.5rem;
                font-weight: normal;
                color: $a-gray-575757;

                .points {
                    color: $green-00987F;
                    font-family: $semi_bold;
                }
            }
        }
    }

    .modal-privilege {
        @extend %modal-base;
    }
</style>
